import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import * as _ from 'lodash';
import { Icon } from 'dlweb-components'
import { Menu } from 'antd';
 
const MenuBar = (props) => {

  const [menuItems, setMenuItems] = useState([])

  useEffect(() => {
    setMenuItems(_.flatMap([...props.menuItems || []]));
  }, [props.menuItems])

  return(
    <MenuContainer>
      <Menu mode="horizontal" selectable={false}>
      {
        menuItems.map((item) => (
          <Menu.Item
            key={item.id}
            onClick={() => { props.$rootScope.$broadcast(item.action, item.data)}}
          >
            <IconDiv>
              <Icon type={item.icon} size="lg"/>
            </IconDiv>
            <TextDiv>
              {item.text}
            </TextDiv>
          </Menu.Item>
          )
        )
      }
      </Menu>
    </MenuContainer>
  )
}

const MenuContainer = styled.div`
  line-height: 40px;
  width: 100%;
  color: #444;
  z-index: 9990;
  box-sizing: border-box;
  overflow: hidden;
  white-space: nowrap;
  border-bottom: 1px solid #dee0e3;
  user-select: none;
`
const TextDiv = styled.div`
  padding-left: 6px;
  display: inline-block;
`
const IconDiv = styled.div`
  text-align: center;
  display: inline-block;
  padding: 0 2px;
`

export default MenuBar;